import React from 'react'

export const CTA = () => {
  return (
  
    <div className='cta' >
   <a href="https://drive.google.com/file/d/1AS9aGodHHIKwT2_Gb7ppVPE9ptX8aW2u/view?usp=sharing" target="_blank" className='btn'>Dawnload CV</a>
    <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}
